const FORM_SELECTOR = '.contact-us-form';
const FIELD_SELECTOR = '.contact-us-form__field';
const CONTROL_SELECTOR = '.contact-us-form__control';
const ERROR_SELECTOR = '.contact-us-form__error';

const formatPhone = (input) => {
  let numbers = input.value.replace(/\D/g, '');
  if (numbers.length > 10) numbers = numbers.substring(0, 10);

  if (numbers.length > 6) {
    input.value = numbers.replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
  } else if (numbers.length > 3) {
    input.value = numbers.replace(/(\d{3})(\d+)/, '$1-$2');
  } else {
    input.value = numbers;
  }
};

/**
 * Contact us form
 */
(() => {
  const form = document.querySelector(FORM_SELECTOR);
  if (!form) return;

  form.querySelector('.fake-email')?.remove();

  form.querySelectorAll(CONTROL_SELECTOR).forEach((item) => {
    if (!item.required) return;

    const field = item.closest(FIELD_SELECTOR);
    const label = field?.querySelector('.contact-us-form__label');
    if (label && !label.querySelector('.contact-us-form__required')) {
      label.insertAdjacentHTML('beforeend', ' <span class="contact-us-form__required">*</span>');
    }
  });

  const phoneInput = form.querySelector('[name="Telephone"]');
  if (phoneInput) {
    phoneInput.addEventListener('input', () => formatPhone(phoneInput));
  }

  const termsToggle = form.querySelector('.contact-us-form__terms-toggle');
  const termsBlock = form.querySelector('.contact-us-form__terms');
  if (termsToggle && termsBlock) {
    termsToggle.addEventListener('click', () => {
      termsBlock.hidden = !termsBlock.hidden;
    });
  }

  form.addEventListener('submit', (e) => {
    let valid = true;

    form.querySelectorAll(ERROR_SELECTOR).forEach((msg) => {
      msg.hidden = true;
    });

    form.querySelectorAll('input[required], textarea[required], select[required]').forEach((field) => {
      if (field.type === 'checkbox') return;

      const fieldWrap = field.closest(FIELD_SELECTOR);
      const error = fieldWrap?.querySelector(ERROR_SELECTOR);
      if (!field.value) {
        valid = false;
        if (error) error.hidden = false;
      }
    });

    const smsCheckbox = form.querySelector('#textOptIn');
    if (smsCheckbox && !smsCheckbox.checked) {
      valid = false;
      alert('You must agree to receive SMS text messages.');
    }

    if (!valid) e.preventDefault();
  });
})();
